import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons"
import { Tag } from "antd"

import styles from "./badges.module.less"

const TAG_COLOR = {
  good: "success",
  bad: "error",
  neutral: "default"
}

const ARROW = {
  up: <ArrowUpOutlined rotate={45} />,
  down: <ArrowDownOutlined rotate={-45} />
}

// A KPI's change against the comparison period (DAA-2-20 … DAA-2-22): an outlined pill with a
// diagonal arrow, as the design draws it. `change` comes from getPercentChange / getPointChange;
// "n/a", "0%" and "0 pp" carry no arrow.
const ChangeBadge = ({ change }) => {
  if (!change) return null

  return (
    <Tag color={TAG_COLOR[change.tone]} icon={ARROW[change.direction]} className={styles.badge}>
      {change.text}
    </Tag>
  )
}

export default ChangeBadge
